module.exports = __webpack_public_path__ + "static/media/TwehuesSq.72345855.jpg";